import { BenefitsCheckbox, PlanTypeCheckbox } from "../../shared";

const AllPlansFilter = ({
  filtersArray,
  setActuallFilters,
}: {
  filtersArray: string[];
  setActuallFilters: (arr: string[]) => void;
}) => {
  const handleClearCheckboxes = () => {
    const checkedCheckboxes = document.querySelectorAll<HTMLInputElement>(
      "input[type='checkbox']:checked"
    );
    setActuallFilters([]);

    checkedCheckboxes.forEach((checkbox) => {
      checkbox.checked = false;
    });
  };
  return (
    <div className="background-quaternary">
      <div className="grid-container">
        <div className="grid-x">
          <div className="show-for-small-only">
            <div className="cell small-12" style={{ padding: "16px 32px" }}>
              <div className="flex-container hide-for-small-only align-justify">
                <h4 style={{ fontSize: "25px" }}>Filter by:</h4>
                <div
                  className="primary-color font-weight-500"
                  style={{
                    textDecoration: "underline",
                    fontSize: "18px",
                    cursor: "pointer",
                  }}
                  onClick={handleClearCheckboxes}
                >
                  Clear filters
                </div>
              </div>
              <div style={{ display: "flex", justifyContent: "end" }}>
                <div
                  className="primary-color font-weight-500"
                  style={{
                    fontSize: "18px",
                    cursor: "pointer",
                  }}
                  onClick={handleClearCheckboxes}
                >
                  Clear filters
                </div>
              </div>

              <div className="grid-x align-justify">
                <PlanTypeCheckbox
                  filtersArray={filtersArray}
                  setActuallFilters={setActuallFilters}
                />
                <BenefitsCheckbox
                  filtersArray={filtersArray}
                  setActuallFilters={setActuallFilters}
                />
              </div>
            </div>
          </div>
          <div
            className="cell small-12 hide-for-small-only"
            style={{ padding: "16px 32px" }}
          >
            <div className="flex-container align-justify">
              <h4 style={{ fontSize: "25px" }}>Filter by:</h4>
              <div
                className="primary-color font-weight-500"
                style={{
                  textDecoration: "underline",
                  fontSize: "18px",
                  cursor: "pointer",
                }}
                onClick={handleClearCheckboxes}
              >
                Clear filters
              </div>
            </div>

            <div className="grid-x align-justify">
              <PlanTypeCheckbox
                filtersArray={filtersArray}
                setActuallFilters={setActuallFilters}
              />
              <BenefitsCheckbox
                filtersArray={filtersArray}
                setActuallFilters={setActuallFilters}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AllPlansFilter;
